export default __webpack_public_path__ + "static/media/project_bullground_8.6515492c.png";